// extracted by mini-css-extract-plugin
module.exports =  {"repairChoices":"TypeOfRepairPage_repairChoices__TuKtf"};